/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-03T10:29:11.928
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentPublishChannelConfigEditInit,
	getRentPublishChannelConfigView
} from '@api/rentmanage/RentPublishChannelConfig';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getRentPublishChannelConfigEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPublishChannelConfigEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentPublishChannelConfigView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPublishChannelConfigView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
